import type { HttpErrorResponse } from '@angular/common/http';

import type { InvitationBody, Invitation, InvitationsSearchParams } from '@core/invitations-types';
import { createEntityCollectionStore, pipeState, ngrxEvent } from '@core/ngrx-legacy';

import { EntityStoreKey } from '../invitations.types';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<Invitation>()(
  EntityStoreKey.invitations,
  {
    customActions: adapter => ({
      fetchCounters: (state, payload: { params: InvitationsSearchParams; scope: string }) =>
        adapter.markAsPending(state),
      fetchCountersSuccess: (state, payload) =>
        pipeState(
          state,
          next => adapter.setPaginationMeta(next, payload.data.meta, { scope: payload.scope }),
          next => adapter.markAsLoaded(next, { scope: payload.scope, entities: [] }),
        ),

      fetchCountersFailed: (state, payload: { scope: string; error: HttpErrorResponse }) =>
        adapter.setError(state, payload.error, { scope: payload.scope, entities: [] }),
      bulkDeleteInvitations: (state, payload: { ids: number[]; scope: string }) =>
        adapter.markAsPending(state),
      bulkDeleteInvitationsSuccess: (state, payload: { data: { uuid: string }; scope: string }) =>
        adapter.markAsLoaded(state, { scope: payload.scope, entities: [] }),
      bulkDeleteInvitationsFailed: (state, payload: HttpErrorResponse) =>
        adapter.setError(state, payload),

      bulkResendInvitations: (state, payload: { ids: number[]; scope: string }) =>
        adapter.markAsPending(state),
      bulkResendInvitationsSuccess: (state, payload: { data: { uuid: string }; scope: string }) =>
        adapter.markAsLoaded(state, { scope: payload.scope, entities: [] }),
      bulkResendInvitationsFailed: (state, payload: HttpErrorResponse) =>
        adapter.setError(state, payload),

      bulkCreateInvitations: (state, payload: { data: InvitationBody; scope: string }) =>
        adapter.markAsPending(state),
      bulkCreateInvitationsSuccess: (state, payload: { data: { uuid: string }; scope: string }) =>
        adapter.markAsLoaded(state, { scope: payload.scope, entities: [] }),
      bulkCreateInvitationsFailed: (state, payload: HttpErrorResponse) =>
        adapter.setError(state, payload),
      invitationsUpdated: ngrxEvent<void>(),
    }),
  },
);

export {
  selectors as InvitationSelectors,
  actions as InvitationActions,
  reducer as InvitationReducer,
  namespace as InvitationNamespace,
};
